// extracted by mini-css-extract-plugin
module.exports = {"cardsRow":"Home_cardsRow__QWAZB"};